/**
 * @file Manages styles for ReferFriend.
 * @author Amresh
 */
import { css } from 'styled-components';
export default css(["font-size:var(--sc-font-size-h5,", ");margin:20px 0 0;"], function (props) {
  var _props$theme;
  return (_props$theme = props.theme) === null || _props$theme === void 0 ? void 0 : _props$theme.fontSizeH5;
});